import { colors } from 'ui/theme/colors';
import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const Table = ({
  height = 24,
  width = 24,
  color = colors.textPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => {
  const pathColor = getColor(color, isColorInherited);

  return (
    <SvgIcon height={height} width={width} viewBox="0 0 24 24" {...props}>
      <path
        d="M9.33337 5.1333H20"
        stroke={pathColor}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.33337 11.5333H20"
        stroke={pathColor}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.33337 17.9333H20"
        stroke={pathColor}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 3.5H7.2V6.7H4V3.5Z"
        stroke={pathColor}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 10H7.2V13.2H4V10Z"
        stroke={pathColor}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 16H7.2V19.2H4V16Z"
        stroke={pathColor}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};
